import CustomModal from "../CustomModal";
import ReportPDFEmailForm from "./ReportPDFEmailForm";
import { useRef } from "react";
import { generateReceiptPDFBlob, blobToBase64 } from "@/util/exportReceipt";

const ReportEmailPdfModal = ({ header = "Email To", show = false, size = "lg", onHide, receiptData }) => {
  const formRef = useRef();

  const handleSubmit = async () => {
    try {
      const values = formRef.current?.getValues();

      if (!values?.to) return; // basic guard

      // Step 1: Generate PDF blob from receipt data
      const pdfBlob = generateReceiptPDFBlob(receiptData);

      // Step 2: Convert to base64
      const base64PDF = await blobToBase64(pdfBlob);

      // Step 3: Send to your backend API
      await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          from: values.from,
          to: values.to,
          subject: values.subject,
          body: values.body,
          attachment: base64PDF,
          filename: "Receipt.pdf",
        }),
      });

      onHide();
    } catch (err) {
      console.error("Email send failed:", err);
    }
  };

  return (
    <CustomModal
      header={header}
      show={show}
      size={size}
      onHide={onHide}
      closeButtonText="Cancel"
      submitButtonText="Okay"
      onSubmit={handleSubmit}
    >
      <ReportPDFEmailForm ref={formRef} />
    </CustomModal>
  );
};

export default ReportEmailPdfModal;